import { Search,CloseRounded as  Edit,  Delete } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Card, CardContent, Chip, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,  InputFile,  InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance,  DialogType,  FormActions, getLabelMunicipio,getUrlImage } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";






const AddressYupValidation = yup.object({
  municipio:yup.object({
    label:yup.string(),
    value:yup.number()
}).test("is_selected",(value,ctx)=>{
  console.log({value});
   if(  !value.value  ){
    return  ctx.createError({ message: 'Seleccione un municipio' })
   }
   
    return true;
}),
cod_erp:yup.string().required(),
  direccion:yup.string().required(),
  celular:yup.string().required()
});



const schema = yup.object({
  url_imagen: yup.string().required(),
  descripcion: yup.string().required(),
  
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};


const AddressListItem  = ({
  onDeleteIcon,
  municipio,
  cod_erp,
  direccion,
  celular

})=>{

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" >{cod_erp} - {municipio?.label} - {direccion}</Typography> 
          <Typography>Cel: {celular}</Typography>
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}

export const MaestroCategorias = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
    
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros-marketplace/obtener-categorias",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };



    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setProductoSeleccionado(product);
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);

    }

    const onOpenModalItem = (edit=false)=>{
      console.log({edit});
      if (!edit){
        setProductoSeleccionado({});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
     
   
      const urlService = 'maestros-marketplace/crear-editar-categoria';
 
        let payload =  {...dataForm  };
        console.log({payload});
      
        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }



    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"url_imagen",
        keyValue:"url_imagen",
        label:"Imagen",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><img style={{width:'80px',height:'80px'}}  src={getUrlImage(props.value)}  />,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Nombre de la categoria",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"razon_social",
        keyValue:"razon_social",
        label:"Compañia",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"total_items",
        keyValue:"total_items",
        label:"Cant. productos asociados",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      
      {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar  Categoria":'Modificar Categoria',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
       
        {
          key:"url_imagen",
          keyValue:"url_imagen",
          label:"Imagen de la categoria",
          component:InputFile,
          code_entity_save:1,
          inputProps:{
            type:"text",
            code_entity_save:1,
          }
        },
        {
          key:"descripcion",
          keyValue:"descripcion",
          label:"Descripcion de la categoria",
          component:InputWithLabel,
          inputProps:{
            type:"text"
          }
        }
       
       

       
      
      ],
      arrayInputs:[]
    } ;

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }
   
    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >


        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nueva categoria</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}